<template>
  <section id="history">
    <pibot-section-heading>
      <slot>History</slot>
    </pibot-section-heading>

    <v-data-table
      dense
      :loading="loading"
      loading-text="Loading history... Please wait"
      :headers="headers"
      :items="items"
      sort-by="year"
      sort-desc
    >
      <template v-slot:[`item.documents`]="{ item }">
        <span v-for="(document, i) in item.documents" :key="document.title">
          <span v-if="i > 0">, </span>
          <a :href="document.path" target="_blank">{{document.title}}</a>
        </span>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import SectionHeading from '@/components/typography/headings/SectionHeading'

export default {
  name: 'pibot-asset-history',
  components: {
    'pibot-section-heading': SectionHeading
  },
  data () {
    return {
      loading: false,
      headers: [
        {
          text: 'Year',
          value: 'year',
          align: 'start',
          sortable: true
        },
        {
          text: 'Type',
          value: 'type',
          align: 'start',
          sortable: true
        },
        {
          text: 'Documents',
          value: 'documents',
          align: 'start',
          sortable: false
        },
        {
          text: 'Description',
          value: 'description',
          align: 'start',
          sortable: true
        }
      ],
      items: [
        {
          year: 2015,
          type: 'Inspection',
          documents: [
            {
              title: 'Report',
              path: 'about:blank'
            }
          ],
          description: 'In-line Inspection (UT)'
        },
        {
          year: 2010,
          type: 'Maintenance',
          documents: [
            {
              title: 'Report',
              path: 'about:blank'
            },
            {
              title: 'Photograph',
              path: 'about:blank'
            }
          ],
          description: 'Coating repair'
        },
        {
          year: 2009,
          type: 'Inspection',
          documents: [
            {
              title: 'Report',
              path: 'about:blank'
            },
            {
              title: 'Photograph',
              path: 'about:blank'
            }
          ],
          description: 'Dig-up'
        }
      ]
    }
  }
}
</script>
